import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getIsAuthFailedOrder, getOrderAmountInCents, getOrderIsTabbed, getOrderPayments } from '../../selectors/order'
import { getBackbarMode } from '../../selectors/config'
import { getIsKiosk } from '../../selectors/menus'
import TipEntryModal from '../../components/TipEntryModal'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { centsToDollars } from '../../utils/formatters'
import useBackBar from '../hooks/useBackBar'

const AddTipAndFinalizeModals = ({ showTipAndFinalize, setShowTipAndFinalize }) => {
  const isKiosk = useSelector(getIsKiosk)
  const isTab = useSelector(getOrderIsTabbed)
  const isBackBar = useSelector(getBackbarMode)
  const amountInCents = useSelector(getOrderAmountInCents)
  const orderPayments = useSelector(getOrderPayments)
  const isAuthFailedTab = useSelector(getIsAuthFailedOrder)
  const hasPayment = useMemo(() => orderPayments.length > 0, [orderPayments])
  const [showConfirmTotal, setConfirmTotalModal] = useState(false)
  const [tipAmountInCents, setTipAmountInCents] = useState(0)
  const { confirmTipHandler, printSlipHandler } = useBackBar()

  const MissingPaymentModal = () => {
    if (hasPayment) return null

    return (
      <ConfirmModalV2
        onButtonOneClick={() => setShowTipAndFinalize(false)}
        onButtonTwoClick={() => {
          setShowTipAndFinalize(false)
          printSlipHandler()
        }}
        headerText="Missing Payment Method"
        subtext="Please print slip to choose payment method before proceeding."
        buttonOneText="CANCEL"
        buttonTwoText="PRINT SLIP"
        opaque={true}
      />
    )
  }

  const EnterTipModal = () => {
    if (!hasPayment) return null
    if (showConfirmTotal) return null

    return (
      <TipEntryModal
        key="custom"
        title="Enter Tip"
        saveButtonText="FINALIZE"
        isKiosk={isKiosk}
        initialValue={tipAmountInCents}
        onClose={() => setShowTipAndFinalize(false)}
        onSubmit={(tipAmountInCents) => {
          setTipAmountInCents(tipAmountInCents)
          setConfirmTotalModal(true)
        }}
        noCloseOnSubmit={true}
        opaque={true}
      />
    )
  }

  const ConfirmTotalModal = () => {
    if (!hasPayment) return null
    if (!showConfirmTotal) return null

    return (
      <ConfirmModalV2
        onButtonOneClick={() => setConfirmTotalModal(false)}
        onButtonTwoClick={() => {
          setShowTipAndFinalize(false)
          confirmTipHandler(tipAmountInCents)
        }}
        headerText={'Confirm Tip & Close Tab'}
        subtext={`Tip: ${centsToDollars(tipAmountInCents)}`}
        extraSubtext={`Total: ${centsToDollars(amountInCents + tipAmountInCents)}`}
        buttonOneText={'GO BACK'}
        buttonTwoText={'CLOSE TAB'}
        opaque={true}
      />
    )
  }

  const shouldRender = useMemo(() => {
    if (!isBackBar) return false
    if (isKiosk) return false
    if (!isTab && !isAuthFailedTab) return false
    if (!showTipAndFinalize) return false

    return true
  }, [isBackBar, isKiosk, isTab, isAuthFailedTab, showTipAndFinalize])

  if (!shouldRender) {
    return null
  }

  return (
    <>
      <MissingPaymentModal />
      <EnterTipModal />
      <ConfirmTotalModal />
    </>
  )
}

export default AddTipAndFinalizeModals
